import React from "react";
import { Club } from "api/clubs";
import { Subscription } from "api/company";
import { Box } from "@material-ui/core";
import { View } from "features/global/reducer";
import AttentionBanner from "features/admin/B2BFeaturesView/AttentionBanner";
import CompanyProfileView from "./CompanyProfileView";
import "../b2bfeaturesStyle.scss";

interface ProfileTabProps {
    club: Club,
    subscription: Subscription | null,
    onNavigateTo: ({ view, tab }: { view: View, tab?: number }) => void,
}

const ProfileTab = ({ club, subscription, onNavigateTo }: ProfileTabProps) => (
    <>
        <Box className="boxContainer">
            {subscription === null && (
                <AttentionBanner club={club} onNavigateTo={onNavigateTo} />
            )}

            {/* Add Company Profile section here */}

            <CompanyProfileView club={club} />

        </Box>
    </>
);

export default ProfileTab;
